import React from 'react';
import {Col, Row, Table} from "react-bootstrap";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";

const RaportZapelnieniaTabela = ({data}) => {
    const kolorJednorazowe = 'darkorange';
    const kolorOdbicia = '#a83da7';

    const obliczSume = () => {
        let sumaJednorazowe = 0;
        let sumaOdbicia = 0;

        data.forEach(item => {
            sumaJednorazowe += parseInt(item.ilejednorazowe);
            sumaOdbicia += parseInt(item.ileodbic)
        });

        return {sumaJednorazowe,sumaOdbicia}
    };

    return (
        <Row>
            <Col xs={12} lg={6}>
                <Table striped bordered condensed hover>
                    <thead>
                    <tr>
                        <th>{(data[0].datar) ? "Data" : "Godzina"}</th>
                        <th><span className={'label label-ebus-primary'} style={{background: kolorJednorazowe}}>Bilety jednorazowe</span></th>
                        <th><span className={'label label-ebus-primary'} style={{background: kolorOdbicia}}>Odbicia miesięczne</span></th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        data.map(row => (
                            <tr>
                                <td>{(row.datar) ? row.datar : DateAndTimeFormat.formatHHMM(row.godz1p)}</td>
                                <td>{row.ilejednorazowe}</td>
                                <td>{row.ileodbic}</td>
                            </tr>
                        ))
                    }
                    <tr style={{fontSize:'18px',fontWeight:'bold'}}>
                        <td>SUMA</td>
                        <td>{obliczSume().sumaJednorazowe}</td>
                        <td>{obliczSume().sumaOdbicia}</td>
                    </tr>
                    </tbody>
                </Table>
            </Col>
        </Row>


    );
};

export default RaportZapelnieniaTabela;


// WEBPACK FOOTER //
// ./src/modules/raporty/RaportZapelnienia/components/RaportZapelnieniaTabela.js